import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/public/LandingPage';
import { PricingPage } from './pages/public/PricingPage';
import { ComparePage } from './pages/public/ComparePage';
import { ApiDocsPage } from './pages/public/ApiDocsPage';
import { DemoPage } from './pages/public/DemoPage';
import { NotFoundPage } from './pages/public/NotFoundPage';
import {
  SecurityPage, StatusPage, ChangelogPage, TermsPage, PrivacyPage,
  CookiesPage, DpaPage, SubprocessorsPage, AupPage,
} from './pages/public/LegalPages';
import { AboutPage } from './pages/public/AboutPage';
import { ContactPage } from './pages/public/ContactPage';
import { CareersPage } from './pages/public/CareersPage';
import { PressPage } from './pages/public/PressPage';
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage';
import { OnboardingPage } from './pages/onboarding/OnboardingPage';
import { AppHome } from './pages/app/AppHome';
import { MePage } from './pages/app/MePage';
import { MyNumberPage } from './pages/app/MyNumberPage';
import { SurveysPage } from './pages/app/SurveysPage';
import { AnalyticsPage } from './pages/app/AnalyticsPage';
import { LearningPage } from './pages/app/LearningPage';
import { GlobalPayrollPage } from './pages/app/GlobalPayrollPage';
import { ProfilePage } from './pages/app/ProfilePage';
import { PeoplePage } from './pages/app/PeoplePage';
import { EmployeeDetailPage } from './pages/app/EmployeeDetailPage';
import { DocumentsPage } from './pages/app/DocumentsPage';
import { PayrollPage } from './pages/app/PayrollPage';
import { TimeOffPage } from './pages/app/TimeOffPage';
import { AttendancePage } from './pages/app/AttendancePage';
import { CompliancePage } from './pages/app/CompliancePage';
import { ApprovalsPage } from './pages/app/ApprovalsPage';
import { AgentsPage } from './pages/app/AgentsPage';
import { DepartmentsPage } from './pages/app/DepartmentsPage';
import { SettingsPage } from './pages/app/SettingsPage';
import { HiringPage } from './pages/app/HiringPage';
import { PerformancePage } from './pages/app/PerformancePage';
import { ReportsPage } from './pages/app/ReportsPage';
import { BorderBuddyPage } from './pages/app/BorderBuddyPage';
import { YearEndPage } from './pages/app/YearEndPage';
import { AdminInboxPage } from './pages/admin/AdminInboxPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { AdminCompaniesPage } from './pages/admin/AdminCompaniesPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/compare" element={<ComparePage />} />
      <Route path="/api-docs" element={<ApiDocsPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="/status" element={<StatusPage />} />
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/cookies" element={<CookiesPage />} />
      <Route path="/dpa" element={<DpaPage />} />
      <Route path="/subprocessors" element={<SubprocessorsPage />} />
      <Route path="/aup" element={<AupPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/press" element={<PressPage />} />

      {/* Auth */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/register" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />

      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/app" element={<AppHome />} />
      <Route path="/app/me" element={<MePage />} />
      <Route path="/app/profile" element={<ProfilePage />} />
      <Route path="/app/people" element={<PeoplePage />} />
      <Route path="/app/people/:id" element={<EmployeeDetailPage />} />
      <Route path="/app/documents" element={<DocumentsPage />} />
      <Route path="/app/payroll" element={<PayrollPage />} />
      <Route path="/app/global-payroll" element={<GlobalPayrollPage />} />
      <Route path="/app/time-off" element={<TimeOffPage />} />
      <Route path="/app/attendance" element={<AttendancePage />} />
      <Route path="/app/compliance" element={<CompliancePage />} />
      <Route path="/app/my-number" element={<MyNumberPage />} />
      <Route path="/app/approvals" element={<ApprovalsPage />} />
      <Route path="/app/agents" element={<AgentsPage />} />
      <Route path="/app/departments" element={<DepartmentsPage />} />
      <Route path="/app/hiring" element={<HiringPage />} />
      <Route path="/app/performance" element={<PerformancePage />} />
      <Route path="/app/surveys" element={<SurveysPage />} />
      <Route path="/app/learning" element={<LearningPage />} />
      <Route path="/app/reports" element={<ReportsPage />} />
      <Route path="/app/analytics" element={<AnalyticsPage />} />
      <Route path="/app/border-buddy" element={<BorderBuddyPage />} />
      <Route path="/app/year-end" element={<YearEndPage />} />
      <Route path="/app/settings" element={<SettingsPage />} />
      <Route path="/admin" element={<AdminDashboardPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/companies" element={<AdminCompaniesPage />} />
      <Route path="/admin/inbox" element={<AdminInboxPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
